import React from 'react';
import PropTypes from 'prop-types';


export default class VideoBackground extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
          <video id="background-video" loop autoPlay muted>
              <source src={this.props.video_url} type="video/mp4" />
              <source src={this.props.video_url} type="video/ogg" />
          </video>
        );
    }
}

VideoBackground.propTypes = {
    video_url: PropTypes.node,
};



// WEBPACK FOOTER //
// ./src/components/helpers/video/video_background.js